// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"879":"6f76ab5b","957":"9d2e06d4"}[chunkId] + ".js";
};